import React, { useState, useEffect } from "react";
import { Table, Tab, Loader, Modal, Button, Form, Icon } from "semantic-ui-react";
import axios from "axios";

const MastersPage = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [openModalParameter, setOpenModalParameter] = useState(false);
  const [itemSelected, setItemSelected] = useState(null);

  const [dataExams, setDataExams] = useState([]);
  const [dataParameters, setDataParameters] = useState([]);
  const [form, setForm] = useState(null); 
  const [error, setError] = useState(null);

  useEffect(() => {
    // Simulación de datos reales
    setTimeout(() => {
      
      const fetchExams = async () => {
        try {
            const {data} = await axios.get('/api/masters/exams');
            setDataExams(data)
        } catch (error) {
            console.log(error)
            setError("Error cargando examenes")
        }finally{
            setIsLoading(false);
        }
      }

      const fetchParameters = async () => {
        try {
            const {data} = await axios.get('/api/masters/parameters');
            setDataParameters(data)
        } catch (error) {
            console.log(error)
            setError("Error cargando parametros")
        }finally{
            setIsLoading(false);
        }
      }

      fetchExams();
      fetchParameters();

    }, 800);
  }, []);

  // Si está cargando, muestra loader
  if (isLoading) {
    return (
      <Loader active inline="centered" size="medium" content="Cargando datos..." />
    );
  }

  if (error) {
    return <p>{error}</p>
  }

  const openedModal = (item) => {
    setItemSelected(item);
    setForm({
        ...item,
        parametros: item.parametros.map(p => ({
            ...p,
            origin_id:p.id
        }))
    }); // cargamos toda la estructura completa
    setOpenModal(true);
  };

  const openedModalParametro = (item) => {
    setItemSelected(item);
    setForm({
        ...item,
        oldId: item.parametro_id
    }); // cargamos toda la estructura completa
    setOpenModalParameter(true);
  };

  const handleSave = () => {
            console.log(form)
            axios.put(`/api/masters/exams/${form.codigo_examen}`, 
                form
            ).then(() => {
                 alert("Actualizado correctamente");
                setOpenModal(false);
            }).catch((err) => {
                console.error(err);
            alert("Error actualizando");
            })   
    }

  const handleSaveParameters = () => {
            console.log(form)
            axios.put(`/api/masters/parameters/${form.oldId}`, 
                form
            ).then(() => {
                 alert("Actualizado correctamente");
                setOpenModalParameter(false);
            }).catch((err) => {
                console.error(err);
                alert("Error actualizando");
            })   
  }

  const TablaExams = () => (
    <Table celled>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Código</Table.HeaderCell>
          <Table.HeaderCell>Nombre</Table.HeaderCell>
          <Table.HeaderCell></Table.HeaderCell>
        </Table.Row>
      </Table.Header>

      <Table.Body>
        {dataExams.map((p, i) => (
          <Table.Row key={i}>
            <Table.Cell>{p.codigo_examen}</Table.Cell>
            <Table.Cell>{p.nombre}</Table.Cell>
            <Table.Cell collapsing>
              <Icon
                name="edit"
                color="blue"
                link
                onClick={() => openedModal(p)}
              ></Icon>
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  );

  const TablaParameters = () => (
    <Table celled>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Código</Table.HeaderCell>
          <Table.HeaderCell>Nombre</Table.HeaderCell>
          <Table.HeaderCell></Table.HeaderCell>
        </Table.Row>
      </Table.Header>

      <Table.Body>
        {dataParameters.map((p, i) => (
          <Table.Row key={i}>
            <Table.Cell>{p.parametro_id}</Table.Cell>
            <Table.Cell>{p.parametro}</Table.Cell>
            <Table.Cell collapsing>
              <Icon
                name="edit"
                color="blue"
                link
                onClick={() => openedModalParametro(p)}
              ></Icon>
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  );

  const panes = [
    {
      menuItem: "Exámenes",
      render: () => (
        <Tab.Pane>
          <TablaExams />
        </Tab.Pane>
      ),
    },
    {
      menuItem: "Parámetros",
      render: () => <Tab.Pane><TablaParameters/></Tab.Pane>,
    },
  ];

  return (
    <>
      <Tab panes={panes} />

      {openModal && (
        <ModalEdit 
        open={openModal}
        onClose={() => setOpenModal(false)}
        form={form}
        setForm={setForm}
        onSave={handleSave}
      />
      )}

      {openModalParameter && (
        <ModalEditParametro 
        open={openModalParameter}
        onClose={() => setOpenModalParameter(false)}
        form={form}
        setForm={setForm}
        onSave={handleSaveParameters}
      />
      )}
    </>
  );
};

const ModalEdit = ({ open, onClose, form, setForm, onSave }) => {

     const handleChange = (key, value) => {
        
        setForm(prev => ({ ...prev, [key]: value }));
        };

    const handleParametroChange = (i, key, value) => {
        setForm(prev => {
        const newParams = [...prev.parametros];
        newParams[i] = { ...newParams[i], [key]: value };
        return { ...prev, parametros: newParams };
        });
    };

  return (
    <Modal open={open} onClose={onClose} size="large">
      <Modal.Header>Editar exámen</Modal.Header>

      <Modal.Content scrolling>
        {form && (
          <Form>
            <Form.Input
              label="Código del Examen"
              value={form.codigo_examen}
              onChange={(e) => handleChange("codigo_examen", e.target.value)}
            />

            <Form.Input
              label="Nombre del Examen"
              value={form.nombre}
              onChange={(e) => handleChange("nombre", e.target.value)}
            />

            <Form.Input
              label="Sección"
              value={form.seccion}
              onChange={(e) => handleChange("seccion", e.target.value)}
            />

            <br />
            <h4>Parámetros</h4>

            <Table celled compact>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>ID</Table.HeaderCell>
                  <Table.HeaderCell>Nombre</Table.HeaderCell>
                  <Table.HeaderCell>Graficable</Table.HeaderCell>
                  <Table.HeaderCell>Numérico</Table.HeaderCell>
                  <Table.HeaderCell>Posicion</Table.HeaderCell>
                  <Table.HeaderCell>Homólogos</Table.HeaderCell>
                </Table.Row>
              </Table.Header>

              <Table.Body>
                {form.parametros.map((p, index) => (
                  <Table.Row key={index}>
                    <Table.Cell>
                      <Form.Input
                        value={p.id}
                        onChange={(e) =>
                          handleParametroChange(index, "id", e.target.value)
                        }
                      />
                    </Table.Cell>

                    <Table.Cell>
                      <Form.Input
                        value={p.nombre}
                        onChange={(e) =>
                          handleParametroChange(index, "nombre", e.target.value)
                        }
                      />
                    </Table.Cell>

                    <Table.Cell>
                      <Form.Checkbox
                        toggle
                        label="Graficable"
                        checked={p.graficable === 1 || p.graficable === true}
                        value={p.graficable}
                        onChange={(e, data) =>
                          handleParametroChange(index, "graficable",data.checked ? 1 : 0)
                        }
                      />
                    </Table.Cell>

                    <Table.Cell>
                      <Form.Checkbox
                        toggle
                        label="Numerico"
                        checked={p.numerico === 1 || p.numerico === true}
                        value={p.numerico}
                        onChange={(e, data) =>
                          handleParametroChange(index, "numerico",data.checked ? 1 : 0)
                        }
                      />
                    </Table.Cell>

                     <Table.Cell>
                      <Form.Input
                        type="number"
                        value={p.posicion}
                        onChange={(e) =>
                          handleParametroChange(index, "posicion", e.target.value)
                        }
                      />
                    </Table.Cell>

                    <Table.Cell>
                      <Form.Input
                        value={p.homologos}
                        onChange={(e) =>
                          handleParametroChange(index, "homologos", e.target.value)
                        }
                      />
                    </Table.Cell>
                  </Table.Row>
                ))}
              </Table.Body>
            </Table>
          </Form>
        )}
      </Modal.Content>

      <Modal.Actions>
        <Button onClick={onClose}>Cerrar</Button>
        <Button primary onClick={onSave}>Guardar</Button>
      </Modal.Actions>
    </Modal>
  )
  };

const ModalEditParametro = ({ open, onClose, form, setForm, onSave }) => {

     const handleChange = (key, value) => {
        
        setForm(prev => ({ ...prev, [key]: value }));
        };

  return (
    <Modal open={open} onClose={onClose} size="large">
      <Modal.Header>Editar parámetro</Modal.Header>

      <Modal.Content scrolling>
        {form && (
          <Form>
            <Form.Input
              label="Código del Examen"
              value={form.parametro_id}
              onChange={(e) => handleChange("parametro_id", e.target.value)}
            />

            <Form.Input
              label="Nombre del Examen"
              value={form.parametro}
              onChange={(e) => handleChange("parametro", e.target.value)}
            />
          </Form>
        )}
      </Modal.Content>

      <Modal.Actions>
        <Button onClick={onClose}>Cerrar</Button>
        <Button primary onClick={onSave}>Guardar</Button>
      </Modal.Actions>
    </Modal>
  )
  };

export default MastersPage;
